import { render, staticRenderFns } from "./faqcategorydetails.vue?vue&type=template&id=0f0a7d96&scoped=true"
import script from "./faqcategorydetails.vue?vue&type=script&lang=js"
export * from "./faqcategorydetails.vue?vue&type=script&lang=js"
import style0 from "./faqcategorydetails.vue?vue&type=style&index=0&id=0f0a7d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a7d96",
  null
  
)

export default component.exports